import { config } from "canbook-data/config";
import { DbUser } from "canbook-data/user/models";
import {
  DEFAULT_DIAL_CODE,
  COUNTRY_CODES,
} from "canbook-data/util/country-codes";

const DIAL_CODES_SORTED = COUNTRY_CODES.map((country) => country.dialCode).sort(
  (a, b) => b.length - a.length,
);

const getDialCodeFromNumber = (value: string) =>
  DIAL_CODES_SORTED.find((dialCode) => value.startsWith(dialCode));

export const parsePhoneNumberForInput = (fullPhoneNumber?: string | null) => {
  const normalized = (fullPhoneNumber ?? "").replace(/\s/g, "");
  if (!normalized) {
    return { dialCode: DEFAULT_DIAL_CODE, digits: "" };
  }

  if (normalized.startsWith("+")) {
    const dialCode = getDialCodeFromNumber(normalized);
    if (dialCode) {
      return {
        dialCode,
        digits: normalized.slice(dialCode.length).replace(/\D/g, ""),
      };
    }
  }

  return {
    dialCode: DEFAULT_DIAL_CODE,
    digits: normalized.replace(/\D/g, ""),
  };
};

export const executeRecaptcha = async (action = "LOGIN"): Promise<string> => {
  const recaptcha = (window as any).grecaptcha;
  return new Promise<string>((resolve, reject) => {
    recaptcha.ready(() => {
      try {
        recaptcha
          .execute(config.RECAPTCHA_SITE_KEY, { action })
          .then((token: string) => {
            resolve(token);
          })
          .catch((error: any) => {
            reject(error);
          });
      } catch (error) {
        reject(error);
      }
    });
  });
};

export type ProfileComponentCallback = {
  onSuccess: (user: DbUser) => void;
};

export type OtpComponentCallback = {
  onSuccess: (user: DbUser) => void;
  onEditPhone: () => void;
  onEditEmail: () => void;
};

export type PhoneComponentCallback = {
  onSuccess: (verificationId: string, phone: string) => void;
};

export type EmailComponentCallback = {
  onSuccess: (verificationId: string, email: string) => void;
};
